import React, { useState, useEffect } from 'react';

import api from '../api'; // Step 2 wala api import karein
import config from '../config';
import { FaCheckCircle, FaAward, FaBolt } from 'react-icons/fa';
import defaultBg from "../assets/images/bg-image.jpg"; // Fallback Image

const Hero = () => {
  // 1. Initial State (Default values wahi rakhi hain jo hardcoded thi, taaki load hote waqt bhi sahi dikhe)
  const [heroData, setHeroData] = useState({
    badgeText: '⚡ Approved under PM Suryaghar Muft Bijli Yojana',
    titlePrefix: 'Powering',
    titleHighlight: 'Bihar & Jharkhand',
    titleSuffix: 'with Clean, Reliable Solar Energy',
    subtitle: 'Engineer-designed rooftop and commercial solar solutions delivering long-term performance, safety, and real electricity savings.',
    stat1: '500+',
    stat2: '5MW+',
    stat3: '8+',
    stat4: '100%',
    backgroundImageUrl: '' 
  });


  // 2. Fetch Data from Backend
  useEffect(() => {
    const fetchHeroData = async () => {
      try {
       const response = await api.get("/Hero");
        if (response.data) {
          // API Data map kar rahe hain
          setHeroData({
            badgeText: response.data.badgeText,
            titlePrefix: response.data.titlePrefix,
            titleHighlight: response.data.titleHighlight,
            titleSuffix: response.data.titleSuffix,
            subtitle: response.data.subtitle,
            stat1: response.data.stat1_Count,
            stat2: response.data.stat2_Capacity,
            stat3: response.data.stat3_Experience,
            stat4: response.data.stat4_Satisfaction,
            backgroundImageUrl: response.data.backgroundImageUrl
          });
        }
      } catch (error) {
        console.error("Error fetching Hero data, using defaults.", error);
      }
    };

    fetchHeroData();
  }, []);

  // 3. Image Logic: Agar API se image aayi to wo, nahi to Local import
  const bgImage = (heroData.backgroundImageUrl && heroData.backgroundImageUrl !== 'null') 
    ? (heroData.backgroundImageUrl.startsWith('http') ? heroData.backgroundImageUrl : `${config.IMG_BASE_URL}${heroData.backgroundImageUrl}`)
    : defaultBg;

  return (
    <section className="hero" id="home">
      {/* Dynamic Background Image */}
      <div 
        className="hero-background"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          transition: 'background-image 0.5s ease' // Smooth change effect
        }}
      ></div>
      
      {/* Overlay */}
      <div className="hero-overlay"></div>
      
      <div className="hero-content">
        {/* Dynamic Badge */}
        <div className="hero-badge ">
          {heroData.badgeText}
        </div>

        {/* Dynamic Title */}
        <h1 className="hero-title">
          {heroData.titlePrefix} <span className="highlight">{heroData.titleHighlight}</span><br />
          {heroData.titleSuffix}
        </h1>

        {/* Dynamic Subtitle */}
        <p className="hero-subtitle">
          {heroData.subtitle}
        </p>

        {/* Credentials (Static hi rakha hai design consistency ke liye) */}
        <div className="hero-credentials">
          <span>
            <FaCheckCircle style={{ color: '#00D084' }} />
            Empanelled with SBPDCL, NBPDCL & JBVNL
          </span>
          <span>
            <FaAward style={{ color: '#FFD700' }} />
            DPIIT Recognized Startup
          </span>
          <span>
            <FaBolt style={{ color: '#00D084' }} />
            NIT & DTU Alumni Team
          </span>
        </div>

        {/* CTA Buttons */}
        <div className="hero-buttons">
          <a href="#contact" className="btn btn-primary btn-large">
            <i className="bi bi-clipboard-check-fill me-2"></i>
            Get a Free Site Survey
          </a>
          <a href="#contact" className="btn btn-secondary btn-large">
            <i className="bi bi-telephone-fill me-2"></i>
            Talk to a Solar Engineer
          </a>
        </div>

        {/* Dynamic Stats */}
        <div className="hero-stats">
          <div className="stat">
            <div className="stat-number">{heroData.stat1}</div>
            <div className="stat-label">Installations</div>
          </div>
          <div className="stat">
            <div className="stat-number">{heroData.stat2}</div>
            <div className="stat-label">Capacity Installed</div>
          </div>
          <div className="stat">
            <div className="stat-number">{heroData.stat3}</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat">
            <div className="stat-number">{heroData.stat4}</div>
            <div className="stat-label">Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;